'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _users = require('./users.html');

var _users2 = _interopRequireDefault(_users);

var _users3 = require('./users.controller');

var _users4 = _interopRequireDefault(_users3);

require('./users.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var usersComponent = {
  restrict: 'E',
  bindings: {},
  template: _users2.default,
  controller: _users4.default,
  controllerAs: 'vm'
};

exports.default = usersComponent;


// WEBPACK FOOTER //
// ./client/app/common/admin/users/users.component.js